import styled from 'styled-components';
import { AStyled } from '@/shared/ui/elements/link/Link.styled';

export const ButtonStyled = styled(AStyled)`
  display: inline-flex; 
  align-items: center;
  width: max-content;

  img {
    margin-left: 8px;
  }
`;
